// extracted by mini-css-extract-plugin
export default {"background-option":"BackgroundOption_background-option__wAPKF","selected":"BackgroundOption_selected__aDIJm"};